import React, { useMemo, useState } from "react";

import {
  MissingInfoContext,
  type MissingInfoContextValue,
  type MissingInfoPayload,
  type MissingInfoResolved,
} from "./missingInfoContext";

// Provider for the "complete missing info" bridge (7HAI-369). Holds the
// published calc payload AND the resolved-completions handback in state so the
// calc card and the dedicated missing-info page (sibling routes) share them
// across navigation — crucially the `resolved` handback survives the card's
// unmount while the review page is open. Mirrors RowReviewProvider; see
// ./missingInfoContext for the rationale.
export const MissingInfoProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [payload, setPayload] = useState<MissingInfoPayload | null>(null);
  const [resolved, setResolved] = useState<MissingInfoResolved | null>(null);
  const value = useMemo<MissingInfoContextValue>(
    () => ({ payload, setPayload, resolved, setResolved }),
    [payload, resolved],
  );
  return <MissingInfoContext value={value}>{children}</MissingInfoContext>;
};
